<template>
  <div class="list-entity">
    <div class="main">
      <p class="sidebar-helptext">
        {{ $t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.title') }}
      </p>

      <or-textbox
        v-model="listEntity.name"
        :label="$t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.name.label')"
        :placeholder="$t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.name.placeholder')"
        :maxlength="maxNameLength"
        :error="$props.errors.name"
        :invalid="!!$props.errors.name"
        enforceMaxlength
      />

      <or-chips
        :value="listEntity.roles"
        @input="updateRoles"
        :label="$t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.roles.label')"
        :helpText="$t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.roles.helpText')"
        :simpleText="true"
        :error="$props.errors.roles"
        :invalid="!!$props.errors.roles"
      />
    </div>
    <div class="list-items">
      <ListItem
        v-for="(item, index) in listEntity.subLists"
        ref="sub-list"
        :key="item.id || index"
        :id="item.id"
        :list.sync="item.list"
        :canonical-form.sync="item.canonicalForm"
        :used-names="getTakenNames(index)"
        :errors="$props.errors.subLists && $props.errors.subLists[index]"
        :is-deletable="listEntity.subLists.length > 1"
        :is-loading="isLoading"
        @remove="deleteListItem(index)"
      />
    </div>

    <or-button
      class="add-item-btn"
      icon="add"
      size="small"
      type="secondary"
      color="primary"
      disableRipple
      @click="addListItem()"
    >
      {{ $t('model.nlu-model.sidebar.entities.editors.list-entity.listentity.addItem') }}
    </or-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { entitiesLimits } from '@/modules/limits'
import { ENTITY_TYPE } from '../../entity-types'
import ListItem from './ListItem'

const getDefaultListItem = () => ({
  canonicalForm: '',
  list: []
})

export const getDefaultListEntity = () => ({
  id: null,
  type: ENTITY_TYPE.list,
  name: '',
  roles: [],
  subLists: [getDefaultListItem()]
})

export default {
  components: { ListItem },

  props: {
    entity: Object,
    errors: Object,
    isLoading: Boolean
  },

  computed: {
    ...mapState('knowledgebase/entities', ['localEntity']),
    ...mapGetters('knowledgebase/entities', ['allSynonyms']),

    maxNameLength () {
      return entitiesLimits.simple.name.max
    },

    listEntity: {
      get () {
        return this.$props.entity
      },
      set (value) {
        this.$emit('update:entity', value)
      }
    }
  },

  methods: {
    getTakenNames (idx) {
      const names = []
      this.listEntity.subLists.forEach((entity, index) => {
        if (index !== idx) {
          names.push(entity.canonicalForm)
        }
      })
      return names
    },

    updateRoles (roles) {
      this.listEntity.roles = roles.map((role) => role.replace(/`/g, ''))
    },

    addListItem () {
      this.listEntity = {
        ...this.listEntity,
        subLists: [...this.listEntity.subLists, getDefaultListItem()]
      }
    },

    deleteListItem (index) {
      this.listEntity = {
        ...this.listEntity,
        subLists: [
          ...this.listEntity.subLists.slice(0, index),
          ...this.listEntity.subLists.slice(index + 1)
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-entity {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  .main {
    display: flex;
    flex-direction: column;
  }

  .list-items {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
    margin-top: $sp-2;
  }

  .add-item-btn {
    align-self: flex-start;
    min-height: 32px;
    border: none;
    margin-top: $sp-3;
    padding: 0;
  }
}
</style>
